import { formatCurrency, formatDate } from '../../utils'
import Spinner from '../Spinner'
import { Coupon } from '../../types/types'

interface propTypes {
  coupons: Array<Coupon>
  loaded: boolean
}

const ListCouponsComponent = (props: propTypes) => {
  const { coupons, loaded } = props
  const activeCoupons = coupons
    ? coupons.filter((coupon) => coupon.state === 'active')
    : []
  const expiredCoupons = coupons
    ? coupons.filter((coupon) => coupon.state === 'inactive')
    : []

  if (!loaded) {
    return <Spinner />
  }

  if (!coupons.length) {
    return <div>No coupons redeemed.</div>
  }

  return (
    <div className="plus-card">
      <table className="w-100">
        <thead className="plus-card-description">
          <tr>
            <th className="p-15">Code</th>
            <th className="p-15">Details</th>
            <th className="p-15">Discounted</th>
            <th className="p-15">Date</th>
          </tr>
        </thead>
        <tbody>
          {activeCoupons.map((coupon) => {
            return (
              <tr key={coupon.id}>
                <td className="p-15">{coupon.code}</td>
                <td className="p-15">{coupon.displayText}</td>
                <td className="p-15">
                  {formatCurrency(
                    coupon.discountedSum.toString(),
                    coupon.currency,
                  )}
                </td>
                <td className="p-15">{coupon.claimedAt.substring(0, 10)}</td>
              </tr>
            )
          })}
          {expiredCoupons.map((coupon) => {
            return (
              <tr className="text-muted" key={coupon.id}>
                <td className="p-15 text-nowrap">
                  <del>{coupon.code}</del>
                </td>
                <td className="p-15">
                  <del>{coupon.displayText}</del>
                </td>
                <td className="p-15">
                  <del>
                    {formatCurrency(
                      coupon.discountedSum.toString(),
                      coupon.currency,
                    )}
                  </del>
                </td>
                <td className="p-15 text-nowrap">
                  <del>{coupon.claimedAt.substring(0, 10)}</del>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default ListCouponsComponent
